"use strict";

var _classCallCheck = require("/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var site_1 = require("../../config/site");

var paises = {
  BMAR: 'argentina',
  ZJAR: 'argentina',
  BMMX: 'mexico',
  BMPE: 'peru',
  BMPA: 'panama',
  BMCL: 'chile',
  BMEC: 'ecuador',
  BMVE: 'venezuela'
};

var ProvinciaLocalidadFilter = /*#__PURE__*/function () {
  function ProvinciaLocalidadFilter() {
    _classCallCheck(this, ProvinciaLocalidadFilter);
  }

  _createClass(ProvinciaLocalidadFilter, null, [{
    key: "makeFilter",
    value: function makeFilter(filtrosParam) {
      var ubicacion = '';

      if (filtrosParam.provincia) {
        var provinciaSplit = filtrosParam.provincia.split('|');
        ubicacion += '/en-' + provinciaSplit[1];

        if (filtrosParam.localidad) {
          var split = filtrosParam.localidad.split('|');
          ubicacion += '/' + split[2];
        }
      }

      return ubicacion;
    }
  }, {
    key: "parseFilter",
    value: function parseFilter(match) {
      var pais = paises[site_1.siteId];
      var provincia;
      var localidad;

      if (match) {
        if (match.params.provincia) {
          provincia = match.params.provincia;

          if (match.params.localidad) {
            localidad = match.params.localidad;
          }
        }
      }

      return {
        localidad: localidad ? "".concat(pais, "|").concat(provincia, "|").concat(localidad) : undefined,
        provincia: provincia ? "".concat(pais, "|").concat(provincia) : undefined
      };
    }
  }]);

  return ProvinciaLocalidadFilter;
}();

exports.ProvinciaLocalidadFilter = ProvinciaLocalidadFilter;